import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { HeroTestimonialSection } from './components/HeroTestimonialSection';
import { TopTestimonialsSection } from './components/TopTestimonialsSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { MastersSection } from './components/MastersSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { CaseStudiesSection } from './components/CaseStudiesSection';
import { JourneyPath } from './components/JourneyPath';
import { InsaneValueSection } from './components/InsaneValueSection';
export function App() {
  return <div className="w-full min-h-screen bg-page-bg text-ink relative overflow-x-hidden selection:bg-teal-100 selection:text-teal-900" data-id="element-0" data-mp="28sl32w6ujkeg">
      <Nav data-id="element-1" data-mp="3ijxoypkvdyjd" />
      <JourneyPath data-id="element-2" data-mp="3ikh8ubu2yx01" />
      <div className="relative z-10 pt-24 sm:pt-20" data-id="element-3" data-mp="3iiweonbohg2p">
        <Hero data-id="element-4" data-mp="3ii4q3wgi0ilx" />
        <InsaneValueSection data-id="element-5" data-mp="3mlayb9n68jv1" />
        <CaseStudiesSection data-id="element-6" data-mp="3mkho1yp07c85" />
        <ProblemSection data-id="element-7" data-mp="3mjq45l4rr2xp" />
        <TopTestimonialsSection data-id="element-8" data-mp="3rc9d24sih9w6" />
        <SolutionSection data-id="element-9" data-mp="3rbzpsoyupgu6" />
        <HeroTestimonialSection data-id="element-10" data-mp="3rcsxbs5mwadd" />
        <MastersSection data-id="element-11" data-mp="5yjetptzbev" />
        <WhatYouGetSection data-id="element-12" data-mp="6htjo98ovic" />
        <OfferSection data-id="element-13" data-mp="4n7u7q58zd7" />
        <PricingSection data-id="element-14" data-mp="82k72sfnuax" />
      </div>
    </div>;
}